<template>
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
<path d="M2495 4906 c-37 -16 -762 -712 -782 -750 -17 -32 -19 -99 -5 -136 13
-32 59 -76 95 -89 16 -6 101 -11 193 -11 l164 0 0 -480 0 -480 -480 0 -480 0
0 165 c0 183 -6 210 -59 259 -24 23 -42 30 -86 34 -31 2 -67 -1 -84 -7 -37
-16 -740 -746 -757 -788 -18 -41 -18 -85 0 -126 17 -42 720 -772 757 -788 17
-6 53 -9 84 -7 44 4 62 11 86 34 53 49 59 76 59 259 l0 165 480 0 480 0 0
-480 0 -480 -164 0 c-92 0 -177 -5 -193 -11 -36 -13 -82 -57 -95 -89 -14 -37
-12 -104 5 -136 21 -40 746 -734 784 -750 41 -18 85 -18 126 0 42 17 772 719
787 757 7 16 10 53 8 84 -4 44 -11 62 -34 86 -49 53 -76 59 -259 59 l-165 0 0
480 0 480 480 0 480 0 0 -165 c0 -183 6 -210 59 -259 24 -23 42 -30 86 -34 31
-2 67 1 84 7 37 16 740 746 757 788 18 41 18 85 0 126 -17 42 -720 772 -757
788 -17 6 -53 9 -84 7 -44 -4 -62 -11 -86 -34 -53 -49 -59 -76 -59 -259 l0
-165 -480 0 -480 0 0 480 0 480 165 0 c183 0 210 6 259 59 23 24 30 42 34 86
2 31 -1 68 -8 84 -15 38 -745 740 -787 757 -40 17 -89 17 -128 0z"/>
</g>
</svg>
</template>